export const FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'

export function disableTabbing(root: HTMLElement) {
  root.querySelectorAll<HTMLElement>(FOCUSABLE).forEach((el) => {
    const prev = el.getAttribute('tabindex')
    if (prev !== null) el.setAttribute('data-prev-tabindex', prev)
    el.setAttribute('tabindex', '-1')
    el.setAttribute('aria-hidden', 'true')
  })
}

export function enableTabbing(root: HTMLElement) {
  const disabledElements = root.querySelectorAll<HTMLElement>('[aria-hidden="true"],[data-prev-tabindex]')
  disabledElements.forEach((el) => {
    const prev = el.getAttribute('data-prev-tabindex')
    if (prev !== null) {
      el.setAttribute('tabindex', prev)
      el.removeAttribute('data-prev-tabindex')
    } else {
      el.removeAttribute('tabindex')
    }
    el.removeAttribute('aria-hidden')
  })
}
